const WEATHER_API_KEY = '555eb1488376452caef233100262005';
const WEATHER_API_URL = 'https://api.weatherapi.com/v1/current.json';

const STORES = [
    {
        name: 'Fig Bar Ambleside',
        city: 'West Vancouver',
        latitude: 49.327176458847774,
        longitude: -123.15259678834332,
    },
    {
        name: 'Fig Bar Kitsilano',
        city: 'Vancouver',
        latitude: 49.26808101957894,
        longitude: -123.15155445582164,
    },
    {
        name: 'Fig Bar Mount Pleasant',
        city: 'Vancouver',
        latitude: 49.25344755890357,
        longitude: -123.10072862883567,
    },
    {
        name: 'Fig Bar Ossington',
        city: 'Toronto',
        latitude: 43.64548521859742,
        longitude: -79.41945485582167,
    },
    {
        name: 'Fig Bar Summerhill',
        city: 'Toronto',
        latitude: 43.682822838299124,
        longitude: -79.39205848650701,
    },
    {
        name: 'Fig Bar Midtown',
        city: 'Toronto',
        latitude: 43.712879011419524,
        longitude: -79.39939895767134,
    },
    {
        name: 'Fig Bar WeHo',
        city: 'Los Angeles',
        latitude: 34.08802437969756,
        longitude: -118.34247995767134,
    },
    {
        name: 'Fig Bar Culver Steps',
        city: 'Culver City',
        latitude: 34.02677794243555,
        longitude: -118.39398422741411,
    },
];

const FALLBACK_STORE = STORES.find((store) => store.name === 'Fig Bar WeHo') || STORES[0];

const selectors = {
    store: '#location, .footer__geo-info .footer__control-title',
    city: '#footer-city',
    time: '#footer-time',
    condition: '#foote-weather-condition, #footer-weather-condition',
    feelsLike: '#weather, #footer-weather',
};

function getDistanceInKm(fromLatitude, fromLongitude, toLatitude, toLongitude) {
    const earthRadiusKm = 6371;
    const latitudeDistance = toRadians(toLatitude - fromLatitude);
    const longitudeDistance = toRadians(toLongitude - fromLongitude);
    const startLatitude = toRadians(fromLatitude);
    const endLatitude = toRadians(toLatitude);

    const haversine =
        Math.sin(latitudeDistance / 2) ** 2 +
        Math.cos(startLatitude) * Math.cos(endLatitude) * Math.sin(longitudeDistance / 2) ** 2;

    return 2 * earthRadiusKm * Math.atan2(Math.sqrt(haversine), Math.sqrt(1 - haversine));
}

function toRadians(value) {
    return (value * Math.PI) / 180;
}

function findNearestStore(latitude, longitude) {
    return STORES.reduce((nearestStore, store) => {
        const nearestDistance = getDistanceInKm(
            latitude,
            longitude,
            nearestStore.latitude,
            nearestStore.longitude
        );
        const storeDistance = getDistanceInKm(latitude, longitude, store.latitude, store.longitude);

        return storeDistance < nearestDistance ? store : nearestStore;
    }, FALLBACK_STORE);
}

function getUserPosition() {
    return new Promise((resolve) => {
        if (!navigator.geolocation) {
            resolve(undefined);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            (position) => resolve(position.coords),
            () => resolve(undefined),
            {
                enableHighAccuracy: false,
                maximumAge: 1000 * 60 * 30,
                timeout: 5000,
            }
        );
    });
}

async function fetchWeather(store) {
    const url = new URL(WEATHER_API_URL);
    url.searchParams.set('key', WEATHER_API_KEY);
    url.searchParams.set('q', `${store.latitude},${store.longitude}`);
    url.searchParams.set('aqi', 'no');

    const response = await fetch(url.toString());

    if (!response.ok) {
        throw new Error(`WeatherAPI request failed with ${response.status}`);
    }

    return response.json();
}

function formatStoreTime(localtime) {
    const time = localtime?.split(' ')[1];
    if (!time) return '';

    const [hourValue, minute = '00'] = time.split(':');
    const hour = Number(hourValue);
    const period = hour >= 12 ? 'pm' : 'am';
    const displayHour = hour % 12 || 12;

    return `${displayHour}:${minute}${period}`;
}

function formatCondition(conditionText = '') {
    const condition = conditionText.toLowerCase();

    if (condition.includes('sunny')) return 'Sunny';
    if (condition.includes('clear')) return 'Clear Sky';
    if (condition.includes('cloud') || condition.includes('overcast')) return 'Cloudy';

    return 'Cloudy';
}

function updateAll(selector, value) {
    if (!value) return;

    for (const element of document.querySelectorAll(selector)) {
        element.textContent = value;
    }
}

function renderWeather(store, weatherData) {
    const currentWeather = weatherData?.current;
    const weatherLocation = weatherData?.location;
    const feelsLike = currentWeather?.feelslike_f;

    updateAll(selectors.store, store.name);
    updateAll(selectors.city, store.city);
    updateAll(selectors.time, formatStoreTime(weatherLocation?.localtime));
    updateAll(selectors.condition, formatCondition(currentWeather?.condition?.text));
    updateAll(selectors.feelsLike, feelsLike === undefined ? '' : `Feels like ${Math.round(feelsLike)}\u00b0`);
}

async function initWeather() {
    if (!document.querySelector(Object.values(selectors).join(', '))) return;

    const position = await getUserPosition();
    const nearestStore = position
        ? findNearestStore(position.latitude, position.longitude)
        : FALLBACK_STORE;

    try {
        const weatherData = await fetchWeather(nearestStore);
        renderWeather(nearestStore, weatherData);
    } catch (error) {
        console.error(error);
    }
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initWeather, { once: true });
} else {
    initWeather();
}
